import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import client from "@/lib/api";
import { AuthProvider } from "@/lib/auth";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import MasterLog from "@/pages/MasterLog";
import WorkOrders from "@/pages/WorkOrders";
import WorkOrderDocument from "@/pages/WorkOrderDocument";
import Schedule from "@/pages/Schedule";
import Drivers from "@/pages/Drivers";
import Assets from "@/pages/Assets";
import Vendors from "@/pages/Vendors";
import TripLog from "@/pages/TripLog";
import Locations from "@/pages/Locations";
import DieselPrices from "@/pages/DieselPrices";
import DriverSchedules from "@/pages/DriverSchedules";
import Integrations from "@/pages/Integrations";
import Dispatch from "@/pages/Dispatch";
import Users from "@/pages/Users";
import DriverPortal from "@/pages/DriverPortal";
import Deliveries from "@/pages/Deliveries";

const P = ({ children, adminOnly, driverOnly }) => <ProtectedRoute adminOnly={adminOnly} driverOnly={driverOnly}>{children}</ProtectedRoute>;

function App() {
  useEffect(() => { client.post("/seed").catch(() => {}); }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/portal" element={<P driverOnly><DriverPortal /></P>} />
            <Route path="/" element={<P><Dashboard /></P>} />
            <Route path="/master-log" element={<P><MasterLog /></P>} />
            <Route path="/dispatch" element={<P><Dispatch /></P>} />
            <Route path="/work-orders" element={<P><WorkOrders /></P>} />
            <Route path="/wo-doc/:id/:kind" element={<P><WorkOrderDocument /></P>} />
            <Route path="/schedule" element={<P><Schedule /></P>} />
            <Route path="/driver-schedules" element={<P><DriverSchedules /></P>} />
            <Route path="/deliveries" element={<P><Deliveries /></P>} />
            <Route path="/drivers" element={<P><Drivers /></P>} />
            <Route path="/assets" element={<P><Assets /></P>} />
            <Route path="/vendors" element={<P><Vendors /></P>} />
            <Route path="/trips" element={<P><TripLog /></P>} />
            <Route path="/locations" element={<P><Locations /></P>} />
            <Route path="/diesel" element={<P><DieselPrices /></P>} />
            <Route path="/integrations" element={<P><Integrations /></P>} />
            <Route path="/users" element={<P adminOnly><Users /></P>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
